import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './nav-styles.css';

const SmallCalNavBar = ({
  nextMonth,
  previousMonth,
  className,
  onNavigate,
}) => {
  const onPrevious = () => {
    onNavigate(previousMonth, 'month');
  };
  const onNext = () => {
    onNavigate(nextMonth, 'month');
  };
  return (
    <div className={className}>
      <Button.Group size="big" styleName="navbar-buttons">
        <Button
          styleName="left-nav"
          title="left"
          data-cy="repvisits-small-calendar-date-backwards-button"
          icon="caret left"
          onClick={onPrevious}
        />
        <Button
          styleName="right-nav"
          title="right"
          icon="caret right"
          data-cy="repvisits-small-calendar-date-forwards-button"
          onClick={onNext}
        />
      </Button.Group>
    </div>
  );
};

SmallCalNavBar.propTypes = {
  nextMonth: PropTypes.instanceOf(Date),
  previousMonth: PropTypes.instanceOf(Date),
  className: PropTypes.string,
  onNavigate: PropTypes.func.isRequired,
};

export default SmallCalNavBar;
